import { FC } from 'react';
// components
import BottlePriceComponent from 'components/main/BottlePrice/Edit';

const AddBottlePrice: FC = () => <BottlePriceComponent />;

export default AddBottlePrice;
